import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  missingFields: string[];
  profileSection?: string; // tab ou ancora para o perfil, ex: 'dados'
}

const FIELD_LABELS: Record<string, string> = {
  name: 'nome completo',
  birth_date: 'data de nascimento',
  birth_city: 'cidade de nascimento',
  birth_time: 'hora de nascimento',
  birth_chart_data: 'mapa astral completo',
};

const ProfileIncompleteWarning: React.FC<Props> = ({ missingFields, profileSection }) => {
  const profileUrl = profileSection ? `/profile?tab=${profileSection}` : '/profile';

  return (
    <div
      className="rounded-2xl p-6 mb-6"
      style={{ background: 'rgba(245,158,11,0.10)', border: '1px solid rgba(245,158,11,0.35)' }}
    >
      <div className="flex items-start gap-3">
        <span className="text-2xl flex-shrink-0">⚠️</span>
        <div>
          <p className="text-amber-300 font-semibold mb-1">Perfil incompleto</p>
          <p className="text-amber-200/80 text-sm mb-3">
            Para esta leitura você precisa ter preenchido:{' '}
            <span className="font-medium text-amber-200">
              {missingFields.map(f => FIELD_LABELS[f] || f).join(', ')}
            </span>.
          </p>
          <Link
            to={profileUrl}
            className="inline-block px-4 py-2 rounded-xl text-sm font-semibold text-black transition-opacity hover:opacity-90"
            style={{ background: 'linear-gradient(135deg, #f59e0b, #fbbf24)' }}
          >
            Completar perfil agora →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProfileIncompleteWarning;
